import { Directive, ElementRef, OnDestroy, OnInit, inject } from '@angular/core';

import { FloatingStackingService } from './floating-stacking.service';

@Directive({
  selector: '[shrdUicFloatingContainer]'
})
export class FloatingContainerDirective implements OnInit, OnDestroy {
  private readonly stackingService = inject(FloatingStackingService);
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;

  ngOnInit(): void {
    this.stackingService.setScrollContainer(this.element);
  }

  ngOnDestroy(): void {
    this.stackingService.removeScrollContainer(this.element);
  }
}
